(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('HtmlXmlModalController', ["$scope", "$modalInstance", "message", "options", "modalSingletons", function ($scope, $modalInstance, message, options, modalSingletons) {
        if (!_(message).isArray()) {
            message = [message];
        }
        $scope.content = message;
        $scope.options = $.extend({ display: 'text' }, options, true);
        $scope.close = function () {
            $modalInstance.close();
            modalSingletons.close(options.singleton);
        };
        $scope.$on('$routeChangeSuccess', function () {
            $scope.close();
        });
        $scope.selectAll = function () {
            $scope.options.editable = true;
            setTimeout(function () {
                angular.element('#html_xml_viewer').focus();
                angular.element('#html_xml_viewer').select();
            }, 500);
        };
    }]);
    m.factory('htmlXmlModal', ["$modal", "path", "modalSingletons", function ($modal, path, modalSingletons) {
        return {
            show: function (message, options, size) {
                options = $.extend(true, {}, options);
                if (options.singleton) {
                    if (modalSingletons.isOpen(options.singleton)) {
                        return modalSingletons.getInstance(options.singleton);
                    }
                }
                var modalInstance = $modal.open({
                    templateUrl: path('common').ctrl('html-xml-modal').template(),
                    controller: 'HtmlXmlModalController',
                    size: size,
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true,
                    resolve: {
                        message: _.constant(message),
                        options: _.constant(options)
                    },
                    windowClass: options.windowClass
                });
                if (options.singleton) {
                    modalSingletons.open(options.singleton, modalInstance.result);
                }
                return modalInstance.result;
            }
        };
    }]);
}());